import { Component, effect, Inject, input, viewChild, ViewContainerRef } from '@angular/core';
import { WagtailService } from "../services/wagtail.service";
import { WagtailContentRendererFactory } from "./factory.content-renderer";
import {
  ProductCollection,
  WagtailPageResponseInterface,
  WagtailProductsCarouselInterface,
} from "@gea-waldviertler-website/gea-models";
import { PageLoadService } from "@gea-waldviertler-website/shop-lib";
import { SliderComponent } from "../product/slider/slider.component";

@Component({
    selector: 'gea-shop-wagtail-page',
    templateUrl: './wagtail-page.component.html',
    standalone: false
})
export class WagtailPageComponent {

  cmsPageId = input<number>(0)
  cmsPage = input<WagtailPageResponseInterface | null>(null)
  contents = viewChild("contents", { read: ViewContainerRef })

  constructor(
    @Inject(WagtailService) private wagtailService: WagtailService,
    @Inject(PageLoadService) private pageloadService: PageLoadService,
  ) {

    // TODO: this should not be handled here, cmsPage should always be filled from outside
    effect(() => {
      const id = this.cmsPageId()
      if (id > 0) {
        this.pageloadService.getStatusSubject().next(true)
        this.wagtailService.loadPage(this.cmsPageId()).subscribe((response) => {
          this.pageloadService.getStatusSubject().next(false)
        })
      }
    })

    effect(() => {
      let ref = this.contents()
      ref?.clear()
      let pc: WagtailPageResponseInterface | null = null
      if (this.cmsPageId()) {
        pc = this.wagtailService.getPageSignal()() ?? null
      } else {
        pc = this.cmsPage()
      }
      if (! pc || ! pc.content['landing'] || ! ref) {
        return
      }
      for (const contentElement of pc.content['landing']) {
        if (contentElement.type == "shop_productcarousel") {
          this.initProductSlider(ref, contentElement.value as WagtailProductsCarouselInterface)
        } else {
          WagtailContentRendererFactory.renderContentElement(ref, contentElement)
        }
      }
    })
  }

  initProductSlider(ref: ViewContainerRef, contentElement: WagtailProductsCarouselInterface) {
    if (! ref || ! contentElement.products) return
    let ret = ref.createComponent(SliderComponent)

    // TODO: this is a workaround needed for rendering after loading from ssr,
    //  but should be done in WagtailService.loadPage
    if (! (contentElement.products instanceof ProductCollection)) {
      contentElement.products = new ProductCollection(contentElement.products)
    }

    ret.setInput('contents', { collection: contentElement.products, attributes: contentElement.attributes })
    ret.setInput('title', contentElement.title)
  }
}
